import { Grid, Typography } from '@mui/material';
import { useEffect } from 'react';
import Clock from './Clock';
import imageDesktop from '@shared/assets/ImageSearchForm.jpg';

const AlertTime = ({
  pago = false,
  expireTime = 900000,
  searchPath,
  storageKey,
  operationType = 'reserva',
}) => {
  useEffect(() => {
    const refId = document.getElementById('alertTimeContainer');
    if (refId) {
      refId.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);

  const titleText = `¡Ya estás a un paso de confirmar tu ${operationType}!`;
  const subtitleText = `Contás con ${Math.floor(
    expireTime / 60000
  )} minutos para completar el ${
    operationType === 'compra' ? 'pago' : 'proceso'
  }. Una vez finalizado ese tiempo, la disponibilidad de tu selección no estará garantizada y serás redirigido a la página anterior para volver a verificar las opciones disponibles.`;

  return (
    <Grid
      container
      justifyContent="flex-start"
      alignItems="center"
      id="alertTimeContainer"
      sx={{
        width: '100%',
        backgroundImage: {
          xs: `url(${imageDesktop})`,
          sm: `url(${imageDesktop})`,
        },
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: {
          xs: '300px',
          sm: '300px',
        },
      }}
    >
      <Grid className="minWebPadding" sx={{ width: '100%' }}>
        <Grid
          item
          xs={12}
          md={9}
          sx={{
            width: '100%',
            bgcolor: '#fff',
            borderRadius: '15px',
            padding: '25px',
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: '#000',
              fontSize: { xs: '20px', sm: '28px' },
            }}
          >
            {titleText}
          </Typography>

          <Typography
            sx={{
              my: 1,
              fontSize: { xs: '16px', sm: '18px' },
              lineHeight: { xs: 1.2, sm: 1.5 },
              color: '#000',
            }}
          >
            {subtitleText}
          </Typography>

          <Clock
            expireTime={expireTime}
            pago={pago}
            searchPath={searchPath}
            storageKey={storageKey}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AlertTime;
